import React from 'react'
import * as commentDirectorTypes from './commentDirectorTypes'
import useCommentDirector from './useCommentDirector'
import useTranslate from '../../../../i18n/useTranslate'
import MyAccordion from '../../../../control/accordion/accordion'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { FieldArray } from 'react-final-form-arrays'
import RichTextEditor from '../../../../control/richTextEditor/richTextEditor'
import { richEditorRequired } from '../../../../utilities/validate'

//View
const CommentDirectorView = (props: commentDirectorTypes.CommentDirectorViewType) => {
    const { disabled = false, irb1Disable = false, commentTitleList, textRemaining, initialcomment = [], isViewMode, committeeID } = props
    const translate = useTranslate()
    const classes = useStyles()
    const isRequired = {
        errorMessage: `${translate.get('MESSAGE.M013')}`,
        showAsterisk: true,
        triggedValidate: true,
    }
    const addCommas = (num: number) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    const renderTopic = (index: number) => {
        return `${commentTitleList[index]?.no ? `${commentTitleList[index]?.no}. ` : ''}${
            translate.languageStore.currentLanguage === translate.languageKey.th
                ? commentTitleList[index]?.name_th
                : commentTitleList[index]?.name_en
        }`
    }
    return (
        <React.Fragment>
            <FieldArray name="commentDirector">
                {({ fields }) => {
                    return fields?.map((name, index) => (
                        <Grid container item spacing={2} key={index}>
                            <Grid item xs={12} md={12} lg={12}>
                                <React.Fragment>
                                    <MyAccordion
                                        title={renderTopic(index)}
                                        titleIcon={() => <Typography className={classes.errorText}>*</Typography>}
                                    >
                                        <Grid container item spacing={2}>
                                            <Grid item xs={12} md={12} lg={12} key={`${index}.commentList`}>
                                                <RichTextEditor
                                                    name={`${name}.commentList`}
                                                    initialRichTextEditor={initialcomment[index]?.commentList}
                                                    commentTitle={
                                                        translate.languageStore.currentLanguage ===
                                                        translate.languageKey.th
                                                            ? commentTitleList[index]?.name_th
                                                            : commentTitleList[index]?.name_en
                                                    }
                                                    commentTitleID={commentTitleList[index]?.id}
                                                    committeeID={committeeID}
                                                    validates={[richEditorRequired(isRequired.errorMessage)]}
                                                    disabled={disabled}
                                                    irb1Disable={irb1Disable && commentTitleList.length > 1}
                                                    placeholder={`${
                                                        translate.languageStore.currentLanguage ===
                                                        translate.languageKey.th
                                                            ? commentTitleList[index]?.name_th
                                                            : commentTitleList[index]?.name_en
                                                    } (${translate.get('LABEL.NO_COMMENT')} )`}
                                                    isHideToolbar={isViewMode || disabled}
                                                    topicID={initialcomment[index]?.id}
                                                />
                                            </Grid>
                                            {!disabled && textRemaining && textRemaining[index] && (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={12}
                                                    lg={12}
                                                    key={`${index}.textRest`}
                                                    style={{ textAlign: 'end', marginTop: '-22px' }}
                                                >
                                                    <small>
                                                        {translate.get('LABEL.NUMBER_OF_CHARACTERS')} :{' '}
                                                        {addCommas(textRemaining[index])}
                                                    </small>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </MyAccordion>
                                </React.Fragment>
                            </Grid>
                        </Grid>
                    ))
                }}
            </FieldArray>
        </React.Fragment>
    )
}

const useStyles = makeStyles(() => ({
    errorText: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#ff4d4f',
        display: 'inline',
    },
}))

//Controller
const CommentDirector = (props: commentDirectorTypes.CommentDirectorType) => {
    const commentDirectorModel = useCommentDirector(props)
    return <CommentDirectorView {...commentDirectorModel} {...props} />
}

export default CommentDirector
